module.exports = __webpack_public_path__ + "static/media/otp-confirm.71396353.svg";